import React, {useState, useEffect} from 'react';
import {View, StyleSheet} from 'react-native';

import {makeStyles, Tab} from 'react-native-elements'; // rne-netzon replaced

import {useDebounce} from '../../hooks/debounce/useDebounce';

import {
  AdminDoctorDeclinedTab,
  AdminDoctorPendingTab,
  AdminSearchHeader,
  AdminDoctorVerifiedTab,
} from '../../views';

import {useRoute} from '@react-navigation/native';

const AdminDoctorsScreen = () => {
  const route = useRoute();

  const [searchValue, setSearchValue] = useState('');
  const [tabIndex, setTabIndex] = useState(0);

  const debouncedSearchValue = useDebounce(searchValue, 350);

  const onFilterClick = () => {};
  const onExportClick = () => {};

  useEffect(() => {
    const params: any = route.params;

    if (params !== undefined) {
      setTabIndex(+params.tab);
    }
  }, [route]);

  return (
    <View style={styles.rootContainer}>
      <AdminSearchHeader
        title="Doctor Accounts"
        searchValue={searchValue}
        onSearchValueChange={setSearchValue}
        onFilterClick={onFilterClick}
        onExportClick={onExportClick}
      />

      <View style={styles.tabsHeaderContainer}>
        <Tab value={tabIndex} onChange={setTabIndex}>
          <Tab.Item title="License Verification Request" />
          <Tab.Item title="Verified Account(s)" />
          <Tab.Item title="Declined Account(s)" />
        </Tab>
      </View>
      <View style={styles.tabsContentContainer}>
        {tabIndex === 0 && (
          <AdminDoctorPendingTab searchKey={debouncedSearchValue} />
        )}
        {tabIndex === 1 && (
          <AdminDoctorVerifiedTab searchKey={debouncedSearchValue} />
        )}
        {tabIndex === 2 && (
          <AdminDoctorDeclinedTab searchKey={debouncedSearchValue} />
        )}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  rootContainer: {
    height: '100%',
    paddingVertical: 120,
    paddingHorizontal: 72,
  },
  tabsHeaderContainer: {
    marginTop: 32,
  },
  tabsContentContainer: {
    marginTop: 0,
    height: '100%',
  },
});

export default AdminDoctorsScreen;
